import StepGoals from "components/Step/StepGoals";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";

export const MembershipStepGoals = ({
  routePrevStep,
  ...state
}: MembershipState) => {
  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  return (
    <StepGoals
      {...state}
      initialValues={state.goalsValues || undefined}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
    />
  );
};

export const MEMBERSHIP_STEP_GOALS: MembershipStep = {
  component: MembershipStepGoals,
  id: "membership-id-goals",
  slug: "goals",
};

export default MEMBERSHIP_STEP_GOALS;
